.async-suggestion-root {

    u-option {
        padding: 0;
        margin: 0;
    }

    /* Remove check icon from selected option */
    u-option::before {
        display: none;
    }

    u-option[aria-selected="true"] {
        background-color: var(--ds-color-unbranded-surface-tinted);
    }
}

